import { Avatar, message, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { useSelector } from "react-redux";
import { token } from "../../constants/Constants";
import { fetch_customer_details } from "../../endpoints/API";

const CustomerProfileView = ({ selectedCustomerProfile }) => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [customerData, setCustomerData] = useState(null);

  useEffect(() => {
    const fetchCustomerData = async () => {
      if (selectedCustomerProfile?.id) {
        try {
          const response = await fetch_customer_details(selectedCustomerProfile?.id);
          if (!response.statusText=="OK") {
            throw new Error("Network response was not ok");
          }

          const data = response?.data;
          setCustomerData(data);
        } catch (error) {
          message.error(error?.response?.data?.error||"Error fetching customer data:");
        }
      }
    };

    fetchCustomerData();
  }, [selectedCustomerProfile]);

  return (
    <>
      <div className="border-b p-2 rounded-lg shadow-md mt-[1rem] flex">
        <div>
          <div>
            <span className="font-semibold">Name:</span>
            <Tag className="ml-[.5rem]">
              {customerData?.first_name +
                " " +
                (customerData?.middle_name ? customerData?.middle_name : "") +
                " " +
                customerData?.last_name}
            </Tag>
          </div>
          <div className="mt-[.5rem]">
            <span className="font-semibold">Email:</span>
            <Tag className="ml-[.5rem]"> {customerData?.email}</Tag>
          </div>
          <div className="mt-[.5rem]">
            <span className="font-semibold">Phone:</span>
            <Tag className="ml-[.5rem]">{customerData?.phone}</Tag>
          </div>
        </div>
        <div className="ml-auto">
          <Avatar
            size={80}
            // icon={<UserOutlined />}
            src={`${prodTestUrl ? prodTestUrl : baseUrl}${
              customerData?.self_family_member_profile_pic
            }`}
          />
        </div>
      </div>
      <div className="border-b p-2 rounded-lg shadow-md mt-[1rem]">
        <div className="font-semibold">
          Family Member{" "}
          <span className="text-gray-500">
            ({customerData?.family_member?.length})
          </span>
        </div>
        <div className="mt-[1rem]">
          {customerData?.family_member?.map((member) => (
            <div
              key={member.id}
              className="mt-[1rem] flex border rounded-lg p-2"
            >
              <Avatar
                size={60}
                src={`${prodTestUrl ? prodTestUrl : baseUrl}${
                  member?.profile_pic
                }`}
                className="mr-3"
              />
              <div>
                <div>
                  <span className="font-semibold">Name:</span>
                  <Tag className="ml-[.5rem]">
                    {member?.first_name +
                      " " +
                      (member?.middle_name ? member?.middle_name : "") +
                      " " +
                      member?.last_name}
                  </Tag>
                </div>
                <div className="mt-[.5rem]">
                  <span className="font-semibold">Relation:</span>
                  <Tag className="ml-[.5rem]" color="blue">
                    {member?.family_member_type?.name}
                  </Tag>
                </div>
                <div className="mt-[.5rem]">
                  <span className="font-semibold">Health Condition:</span>
                  {member?.health_condition?.length > 0 ? (
                    member?.health_condition?.map((condition, index) => (
                      <Tag key={index} className="ml-[.5rem]">
                        {condition}
                      </Tag>
                    ))
                  ) : (
                    <Tag className="ml-[.5rem]">None</Tag>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>{" "}
      </div>

      <div className="border-b p-2 rounded-lg shadow-md mt-[1rem]">
        <div className="font-semibold">
          Address
          <span className="text-gray-500 ml-1">
            ({customerData?.location?.length})
          </span>
        </div>
        <div className="mt-[1rem]">
          <div>
            <div className="mt-[1rem] ">
              {customerData?.location?.map((address) => (
                <div key={address?.id} className="mb-2 border p-2 rounded-lg">
                  <div>
                    <span className="font-semibold">Label:</span>
                    <Tag className="ml-[.5rem]" color="green">
                      {address?.address_identifier}
                    </Tag>
                  </div>
                  <div className="mt-[.5rem]">
                    <span className="font-semibold">Address:</span>
                    <Tag className="ml-[.5rem]">
                      {address.house_flat_floor_no +
                        " " +
                        " " +
                        address.apartment_road_area}
                    </Tag>
                  </div>
                  <div className="mt-[.5rem]">
                    <span className="font-semibold">Pincode:</span>
                    <Tag className="ml-[.5rem]">{address?.pincode?.pin}</Tag>
                  </div>
                  <div className="mt-[.5rem]">
                    <span className="font-semibold">City:</span>
                    <Tag className="ml-[.5rem]">{address?.city?.name}</Tag>
                  </div>
                  <div className="mt-[.5rem]">
                    <span className="font-semibold">State:</span>
                    <Tag className="ml-[.5rem]">{address?.state?.name}</Tag>
                  </div>
                  <div className="mt-[.5rem]">
                    <span className="font-semibold">Country:</span>
                    <Tag className="ml-[.5rem]">{address?.country?.name}</Tag>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>{" "}
      </div>
    </>
  );
};

export default CustomerProfileView;
